import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import withMUI from "./hoc/withMUI";
import withUser from "./hoc/withUser";
import withAuthentication from "./hoc/withAuthentication";
import Loading from "./components/Loading";
import Deals from "./containers/Deals";
import Invoice from "./containers/Invoice";
import Settings from "./containers/Settings";
import AddCustomer from "./containers/AddCustomer";
import AddInvoicePrintData from "./containers/AddInvoicePrintData";
import AddProduct from "./containers/AddProduct";
import AddUnit from "./containers/AddUnit";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Onboarding from "./components/Onboarding";
import AddOrganisation from "./containers/AddOrganisation";
class App extends React.Component {
  // componentWillMount() {
  //   this.props.firebase.auth.onAuthStateChanged(async authUser => {
  //     if (authUser) {
  //       await localStorage.setItem("user", authUser);
  //     }
  //     this.ren = true;
  //   });
  // }
  render() {
    // if (this.ren) {
    return (
      <div>
        {this.props.user ? (
          <Router>
            <Redirect exact from="/" to="/addOrganisation" />
            <Route path="/deals" render={props => <Deals {...props} />} />
            <Route
              path="/addOrganisation"
              render={props => <AddOrganisation {...props} />}
            />
            <Route path="/invoice" render={props => <Invoice {...props} />} />
            <Route
              path="/settings"
              render={props => <Settings {...props} />}
            />
            <Route
              path="/privacyPolicy"
              render={props => <PrivacyPolicy {...props} />}
            />
            <Route
              path="/addCustomer/:uid"
              render={props => <AddCustomer {...props} />}
            />
            <Route
              path="/updateCustomer/:customerId"
              render={props => <AddCustomer {...props} />}
            />
            <Route
              path="/addInvoicePrintData/:uid"
              render={props => <AddInvoicePrintData {...props} />}
            />
            <Route
              path="/addProduct/:uid"
              render={props => <AddProduct {...props} />}
            />
            <Route
              path="/addUnit/:uid"
              render={props => <AddUnit {...props} />}
            />
          </Router>
        ) : (
            <Router>
              <div>
                <Redirect exact from="/" to="/login" />
                <Route path="/login" render={props => <Onboarding {...props} />} />
                <Route path="/loading" render={props => <Loading {...props} />} />
              </div>
            </Router>
          )}
      </div>
    );
    // } else {
    //   return (
    //     <Router>
    //       <Route path="/loading" render={props => <Loading {...props} />} />
    //     </Router>
    //   );
    // }
  }
}

export default withAuthentication(withMUI(withUser(App)));
